
import { IPagedQuery } from "../components/paginate";

export interface PollingQrProps {
    isModalOpen: boolean;
    filters?: IPagedQuery;
    coursePageClassId?: string;
    dispatch?: any;
    coursePageActivityId?: string;
}

export interface PollingQrState {
    qrCodeValue: string | null;
    isCollapseOpen: boolean;
    currentTab: string;
    filters?: IPagedQuery | null;
    isBlurred: boolean;
    validations?: any;
    isModalOpen?: boolean;
    studentListType?: any;
    selectedClassIds?: any;
    isQrCodeModal?: boolean;
}

export interface IPollingQrReportProps {
    filters: any;
    results: any;
    onChange: any;
    onModalChange?: any;
    dispatch?: any;
    coursePageClassId?: string;
    coursePageActivityId?: string;
    selectedTakeOption?: any;
}

export interface IPollingQrReportItem {
    date: Date;
    owner: string;
    total: number;
    participated: number;
}

export const FilterInitialValues: IPagedQuery = {
    orderBy: '',
    query: '',
    page: 1,
    total: -1,
    skip: 0,
    take: 10
};